import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

export const fetchAllBusinesses = () => {
  return Api(endPoints.fetchAllBusinesses, null, requestType.GET);
};
export const fetchBusinessReport = (params) => {
  return Api(endPoints.fetchBusinessReport, params, requestType.POST);
};
